/**
 * @file Global numbers
 */

// 104.8576 MB
export const BYTES_FOR_15_MIN_AUDIO_RECORDING = 104857600
// Please change the constant at GoogleCloudResumableUploader.capped_file_size_limit
// if we do change this.
// 2147.483648 MB
export const BYTES_FOR_5_MIN_VIDEO_RECORDING = 2147483648

// Refer to MIN_PASSWORD_LENGTH and MAX_PASSWORD_LENGTH in app/models/user.rb
export const OLD_MIN_PASSWORD_LENGTH = 6 // Some older accounts have passwords that have not been changed since we increased the minimum length to 8
export const MIN_PASSWORD_LENGTH = 8
export const MAX_PASSWORD_LENGTH = 128
export const MAX_NAME_LENGTH = 110

// Refer to MAX_LENGTH in app/models/namespace.rb
export const MAX_NAMESPACE_LENGTH = 64

// Soft limit on frontend
export const MIN_SECTION_TITLE_LENGTH = 1
export const MAX_SECTION_TITLE_LENGTH = 128

// Character limits
// Refer to SUBJECT_CHARACTER_LIMIT and BODY_CHARACTER_LIMIT in app/models/wish.rb
export const POST_SUBJECT_CHARACTER_LIMIT = 500
export const POST_BODY_CHARACTER_LIMIT = 10000

// Refer to BODY_CHARACTER_LIMIT in app/models/comment.rb
export const COMMENT_BODY_CHAR_LIMIT = 10000
